import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ProgramGanttViewComponent } from './program-gantt-view.component';
import { DxDataGridModule } from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProgramGanttViewRoutingModule } from './program-gantt-view-routing.module';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    ProgramGanttViewRoutingModule
  ],
  declarations: [
    ProgramGanttViewComponent
  ]
})
export class ProgramGanttViewModule { }
